export default __webpack_public_path__ + "static/media/oc-bg.52d9a693.png";